<template>
  <el-card class="box-card form-screen staff-create mb-50">
    <el-row>
      <el-col :span="24">
        <div class="card-header" v-if="staff && staff.id">
          <span class="font-weight-700">{{ $t('staff.form.input_labels.id') }} {{ staff.id }}</span>
          <hr>
        </div>
        <el-form :rules="rules" :model="form" ref="form" id="form" method="post" :action="urls.action">
          <div v-if="role != $userRole.partner.staff">
            <el-form-item prop="company_id" :error="getErrorForField('company_id', errors)">
              <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.company') }} <span class="text-required">{{ $t('required') }}</span></label>
              <el-select
                v-model="form.company_id"
                :placeholder="$t('staff.form.input_placeholder.company')"
                :no-match-text="$t('no_data')"
                @change="onChangeSelectShop"
                filterable
              >
                <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="shop_id" :error="getErrorForField('shop_id', errors)">
              <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.shop') }} <span class="text-required">{{ $t('required') }}</span></label>
              <el-select
                v-model="form.shop_id"
                :placeholder="$t('staff.form.input_placeholder.shop')"
                :disabled="disableSelectShop"
                :no-data-text="$t('no_data')"
              >
                <el-option v-for="item in shops" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="role == $userRole.partner.staff">
            <el-form-item>
              <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.company') }} <span class="text-required">{{ $t('required') }}</span></label>
              <el-input :value="staff.company.name" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.shop') }} <span class="text-required">{{ $t('required') }}</span></label>
              <el-input :value="staff.shop.name" :disabled="true"></el-input>
            </el-form-item>
          </div>
          <el-form-item prop="occupation" :error="getErrorForField('occupation', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.occupation') }}</label>
            <el-input name="occupation" v-model="form.occupation" :placeholder="$t('staff.form.input_placeholder.occupation')" @blur="trim('occupation')"></el-input>
          </el-form-item>
          <el-form-item class="full-name mt-10">
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.name') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-row>
              <div class="el-col mr-20 w-190">
                <el-form-item prop="first_name" :error="getErrorForField('first_name', errors)">
                  <el-input name="first_name" v-model="form.first_name" :placeholder="$t('staff.form.input_placeholder.first_name')" class="input-small" @blur="trim('first_name')"></el-input>
                </el-form-item>
              </div>
              <div class="el-col w-190">
                <el-form-item prop="last_name" :error="getErrorForField('last_name', errors)">
                  <el-input name="last_name" v-model="form.last_name" :placeholder="$t('staff.form.input_placeholder.last_name')" class="input-small" @blur="trim('last_name')"></el-input>
                </el-form-item>
              </div>
            </el-row>
          </el-form-item>
          <el-form-item prop="nickname" :error="getErrorForField('nickname', errors)">
            <label slot="label" class="el-form-item__label">
              {{ $t('staff.form.input_labels.nickname') }}
              <span class="text-required">{{ $t('required') }}
            </span></label>
            <el-input name="nickname" v-model="form.nickname" :placeholder="$t('staff.form.input_placeholder.nickname')" @blur="trim('nickname')"></el-input>
          </el-form-item>
          <el-form-item prop="avatar_image_url" :error="getErrorForField('avatar_image_url', errors)" class="file-input">
            <label slot="label" class="el-form-item__label mb-5">{{ $t('staff.form.input_labels.avatar') }}</label>
            <el-avatar :size="100" :src="imageUrl" v-if="imageUrl" class="mr-10"/>
            <label class="btn-upload">
              <input type="file" name="avatar" @change="onFileChange" id="avatar" accept="image/jpg, image/jpeg, image/png">ファイルを選択
            </label>
            <span class="file-name">{{ form.image_name }}</span>
            <div class="text-error-custom">{{ imageError }}</div>
          </el-form-item>
          <el-form-item prop="birthday" :error="getErrorForField('birthday', errors)" class="w-400">
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.birthday') }}</label>
            <date-form @change-date="setBirthday" :date="form.data_birthday"></date-form>
          </el-form-item>
          <el-form-item>
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.gender') }}</label>
            <el-radio-group v-model="form.gender">
              <el-radio :label="item.key" name="gender" v-for="item in listGender" :key="item.key">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="mail_address" :error="getErrorForField('mail_address', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.mail_address') }} <span class="text-required" v-if="(role == $userRole.partner.staff || isPageCreate()) && role !== $userRole.partner.staff">{{ $t('required') }}</span> </label>
            <el-input name="mail_address" v-model="form.mail_address" :readonly="site == $siteType.site_partner && !isPageCreate()" :placeholder="$t('staff.form.input_placeholder.mail_address')" @blur="trim('mail_address')"></el-input>
          </el-form-item>
          <p class="verify_mail" @click="handleRedirect" v-if="site == $siteType.site_partner && !isPageCreate()">{{ $t('staff.form.btn_redirect') }}</p>
          <div class="group-input"><span>{{ $t('staff.account_info') }}</span></div>
          <el-form-item prop="login_id" :error="getErrorForField('login_id', errors)" v-if="Object.keys(staff).length <= 0 || staff.partner_user.login_type != $loginType.line">
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.login_id') }} <span class="text-required">{{ $t('required') }}</span> </label>
            <el-input name="login_id" v-model="form.login_id" :placeholder="$t('staff.form.input_placeholder.login_id')" @blur="trim('login_id')"></el-input>
          </el-form-item>
          <el-form-item>
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.status') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-radio-group v-model="form.status">
                <el-radio label="1" name="status">{{ $t('status.active') }}</el-radio>
                <el-radio label="0" name="status">{{ $t('status.inactive') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="order_number" :error="getErrorForField('order_number', errors)" v-show="role != $userRole.partner.staff">
            <label slot="label" class="el-form-item__label">{{ $t('staff.form.input_labels.order_number') }} </label>
            <el-row>
              <div class="el-col w-190">
                <el-input class="order-number-custom" name="order_number" v-model="form.order_number" :placeholder="$t('staff.form.input_placeholder.order_number')" @blur="trim('order_number')"></el-input>
              </div>
            </el-row>
          </el-form-item>
          <div class="group-input group-input-intro"><span>{{ $t('staff.description_reply') }}</span></div>
          <el-form-item prop="description" :error="getErrorForField('description', errors)">
            <label slot="label" class="el-form-item__label white-space-pre-line">{{ $t('staff.form.input_labels.description') }} <span class="text-required">{{ $t('required') }}</span> </label>
            <el-input name="description" v-model="form.description" :placeholder="$t('staff.form.input_placeholder.description')" type="textarea" @blur="trim('description')"></el-input>
          </el-form-item>
          <el-form-item  prop="message_text" :error="getErrorForField('message_text', errors)">
            <label slot="label" class="el-form-item__label white-space-pre-line">{{ $t('staff.form.input_labels.message_text') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="message_text" v-model="form.message_text" :placeholder="$t('staff.form.input_placeholder.message_text')" type="textarea" class="textarea" @blur="trim('message_text')"></el-input>
          </el-form-item>
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="shop_id" :value="form.shop_id">
          <input type="hidden" name="company_id" :value="form.company_id">
          <input type="hidden" name="birthday" :value="form.birthday">
          <input type="hidden" name="avatar_image_url" :value="form.avatar_image_url">
          <input type="hidden" name="file_name" :value="form.image_name">
          <input type="hidden" name="id" :value="staff.id" v-if="staff && staff.id">
          <el-form-item class="btn-container staff-create-container">
            <el-button type="primary" @click="submit('form')" class="btn btn-submit">{{ btn }}</el-button>
            <el-button @click="back" class="btn btn-back">{{ $t('back') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
  import { YEARS, MONTHS, GENDERS, IMAGE_EXTENSIONS, LOGIN_TYPE } from '../../constants'
  import { getListShopOfCompany } from '../../api/company'
  import { checkUniqueStaff } from '../../api/staff'
  import { upload } from '../../api/upload'
  import { getCompanyOfShop } from '../../api/shop'

  export default {
    props: {
      companies: { type: Array, required: false, default: [] },
      errors: { type: Object, required: false },
      input: { type: Object, required: false },
      staff: { type: Object, default: {} },
      urls: { type: Object, required: true, default: {} },
      btn: { type: String, required: true, default: '' },
      info: { type: Object, required: false, default: {} },
      role: { type: Number, required: false },
      site: { type: Number, required: false },
    },
    data() {
      const checkRegexLoginId = (rule, value, callback) => {
        const regex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,255}$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.login_id.format')));
        } else {
          if (this.site === this.$siteType.site_partner) {
            checkUniqueStaff(this.form.id, value, Object.keys(this.staff).length !== 0 ? this.staff.partner_user.id : null)
              .then(response => response.json())
              .then(response => {
                if (response && response.status_code === 200) {
                  callback();
                }
              }).catch(e => e ? callback(new Error(this.$t('errors.login_id.already_exist'))) : '')
          } else {
            callback();
          }
        }
      };

      const checkEmpty = (rule, value, callback) => {
        if (['mail_address'].includes(rule.field)) {
          if ((this.role !== this.$userRole.partner.staff && !this.isPageCreate()) || this.role == this.$userRole.partner.staff) {
            callback();
          } else {
            if (!value || value.trim().length === 0) {
              callback(new Error('error'));
            } else {
              callback();
            }
          }
        } else {
          if (!value || value.trim().length === 0) {
            callback(new Error('error'));
          } else {
            callback();
          }
        }
      };

      const checkBirthday = (rule, value, callback) => {
        if (new Date(this.form.birthday) > new Date()) {
          callback (new Error (this.$t('errors.date.after' , [this.$t('staff.form.input_labels.birthday')])));
        } else {
          callback();
        }
      };

      const validateNumber = (rule, value, callback) => {
        const regex = new RegExp(/^\d+$/);
        if (!regex.test(value) && value) {
          callback(new Error(this.$t('errors.numeric', [this.$t('staff.form.input_placeholder.order_number')])))
        } else {
          callback()
        }
      };

      return {
        form: {
            company_id: '',
            shop_id: '',
            occupation: '',
            first_name: '',
            last_name: '',
            nickname: '',
            name: '',
            avatar_image_url: '',
            data_birthday: { year: '', month: '', day: '' },
            birthday: '',
            gender: 1,
            mail_address: '',
            login_id: '',
            status: '1',
            description: '',
            message_text: '',
            login_type: '',
            order_number: '',
            image_name: this.$t('no_file_choose')
        },
        rules: {
          company_id: [
            { required: true, message: this.$t('errors.required', [this.$t('staff.form.input_labels.company')]), trigger: 'blur' },
          ],
          shop_id: [
            { required: true, message: this.$t('errors.required', [this.$t('staff.form.input_labels.shop')]), trigger: 'blur' },
          ],
          occupation: [
            { max: 255, message: this.$t('errors.max', [this.$t('staff.form.input_placeholder.occupation'), 255]), trigger: 'blur' },
          ],
          first_name: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('staff.form.input_placeholder.first_name')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('staff.form.input_placeholder.first_name'), 255]), trigger: 'blur' },
          ],
          last_name: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('staff.form.input_placeholder.last_name')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('staff.form.input_placeholder.last_name'), 255]), trigger: 'blur' },
          ],
          nickname: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('staff.form.input_placeholder.nickname')]), trigger: 'blur' },
            { max: 30, message: this.$t('errors.max', [this.$t('staff.form.input_placeholder.nickname'), 30]), trigger: 'blur' },
          ],
          mail_address: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('staff.form.input_placeholder.mail_address')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('staff.form.input_placeholder.mail_address'), 255]), trigger: 'blur' },
            { type: "email", message: this.$t('errors.mail'), trigger: 'blur' }
          ],
          login_id: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('staff.form.input_placeholder.login_id')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('staff.form.input_placeholder.login_id'), 255]), trigger: 'blur' },
            { min: 8, message: this.$t('errors.min', [this.$t('staff.form.input_placeholder.login_id'), 8]), trigger: 'blur' },
            { validator: checkRegexLoginId, trigger: 'blur' },
          ],
          description: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('staff.form.input_placeholder.description')]), trigger: 'blur' },
          ],
          message_text: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('staff.form.input_placeholder.message_text')]), trigger: 'blur' },
          ],
          birthday: [
            { validator: checkBirthday, trigger: 'blur' },
          ],
          order_number: [
            { max: 3, message: this.$t('errors.number.max', [this.$t('staff.form.input_placeholder.order_number'), 3]), trigger: 'blur' },
            { validator: validateNumber, trigger: 'blur' },
          ],
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        labelBtnSubmit: this.$t('create'),
        years: YEARS,
        months: MONTHS,
        shops: [],
        disableSelectShop: true,
        listGender: GENDERS,
        imageError: '',
        imageUrl: ''
      }
    },

    methods: {
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid && !this.imageError) {
            const form = document.getElementById("form");
            const file = document.getElementById('avatar').files[0];
            if (file) {
              this.uploadFileAndSubmit(file, form);
            } else {
              document.querySelector(".el-container").classList.add("disabled");
              document.querySelector("#loader").style.display = "block";
              form.submit();
            }
          } else {
            return false;
          }
        });
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },

      back() {
        window.location.href = this.urls.back;
      },

      isPageCreate() {
        const url = new URL(window.location.href)
        return url.pathname.includes('create')
      },

      onFileChange(e) {
        const file = e.target.files[0];
        const extension = file.name.split('.').pop();
        this.form.image_name = file.name;
        if (!IMAGE_EXTENSIONS.includes(extension)) {
          this.imageError = this.$t('errors.image.type');
          this.imageUrl = '';
          return;
        }
        if (file.size > this.$maxSizeImageByte) {
          this.imageError = this.$t('errors.image.max', [this.$t('staff.form.input_labels.avatar'), this.$maxSizeImage]);
          this.imageUrl = '';
          return;
        }

        this.imageError = '';
        this.imageUrl = URL.createObjectURL(file);
      },

      onChangeSelectShop() {
        this.form.shop_id = '';
        this.getListShopOfCompany();
      },

      getListShopOfCompany() {
        if (!this.form.company_id) {
          return;
        }

        getListShopOfCompany(this.form.company_id)
        .then(response => response.json())
        .then(response => {
          this.shops = response.data;
          this.disableSelectShop = false;
        })
      },

      uploadFileAndSubmit(file, form) {
        upload(file)
        .then(response => response.json())
        .then(response => {
          this.form.avatar_image_url = response.data.url;
          this.form.image_name = response.data.file_name;
          this.imageUrl = response.data.url;
        })
        .then(() => {
          document.querySelector(".el-container").classList.add("disabled");
          document.querySelector("#loader").style.display = "block";
          form.submit();
        });
      },

      getCompanyOfShop(shop_id) {
        if (this.role != this.$userRole.partner.staff) {
          getCompanyOfShop(shop_id)
            .then(response => response.json())
            .then(response => {
              this.form.company_id = response.data.id;
            })
            .then(() => {
              this.getListShopOfCompany();
          });
        }
      },

      setBirthday(data) {
        const tmp = {};
        tmp.month  = data.month ? data.month : '01';
        tmp.day  = data.day ? data.day : '01';
        tmp.year = data.year;
        this.form.data_birthday = data;
        this.form.birthday = this.$dayjs(`${tmp.year}/${tmp.month}/${tmp.day}`).format('YYYY/MM/DD');
        this.$refs['form'].validateField('birthday');
      },

      trim(field) {
        if (this.form[field]) {
          this.form[field] = this.form[field].trim();
        }
      },

      handleRedirect() {
        if (this.role === 3) {
          window.location.href = '/my-page/change-mail'
        } else {
          window.location.href = `/staff/${this.staff.id}/change-mail`
        }
      }
    },

    created() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      const tempData = (Object.keys(this.input).length === 0) ? this.staff : this.input;
      this.form = Object.fromEntries(Object.entries(tempData).map(([key, value]) => [key, value]));

      this.form.status = (tempData.hasOwnProperty('status')) ? tempData.status.toString() : '1';
      this.form.gender = (tempData.hasOwnProperty('gender')) && tempData.gender ? tempData.gender.toString() : '1';
      this.form.company_id = (tempData.company_id) ? parseInt(tempData.company_id) : '';
      this.form.shop_id = (tempData.shop_id) ? parseInt(tempData.shop_id) : '';
      this.form.order_number = (tempData.order_number) ? String(tempData.order_number) : '';
      this.form.image_name = (tempData.file_name) ? tempData.file_name : this.$t('no_file_choose');
      this.imageUrl = (tempData.avatar_image_url) ? tempData.avatar_image_url : '';

      if (tempData.birthday) {
        this.form.birthday = this.$dayjs(tempData.birthday).format('YYYY/MM/DD');
        this.form.data_birthday = {
          year: this.$dayjs(tempData.birthday).format('YYYY'),
          month: this.$dayjs(tempData.birthday).format('MM'),
          day: this.$dayjs(tempData.birthday).format('DD')
        }
      }

      if (urlParams.get('shop_id') && !tempData.shop_id) {
        this.getCompanyOfShop(urlParams.get('shop_id'));
        this.form.shop_id = parseInt(urlParams.get('shop_id'));
      } else if (tempData.shop_id) {
        this.getCompanyOfShop(tempData.shop_id);
        this.form.shop_id = parseInt(tempData.shop_id);
      }

      if (this.role == this.$userRole.partner.company) {
        this.form.company_id = this.info.company_id;
        this.disableSelectShop = false;
        this.getListShopOfCompany();
      }

      if (this.role == this.$userRole.partner.shop) {
        this.form.shop_id = this.info.shop_id;
        this.getCompanyOfShop(this.info.shop_id);
        this.form.company_id = this.info.company_id;
      }

      if (this.role == this.$userRole.partner.staff) {
        this.form.company_id = this.staff.company.id;
      }
   },
  }
</script>

<style lang="scss">
  .mb-5 {
    margin-bottom: 5px;
  }
  .full-name {
    .el-form-item__content {
      margin-top: 0;
    }
  }
  .staff-create {
    .el-form {
      .group-input-intro {
        margin-top: 18px;
      }
      .note-login-id {
        margin-top: 30px;
        padding-top: 40px;
        padding-bottom: 40px;
        padding-left: 30px;
      }
      .staff-create-container {
        .el-form-item__content {
          margin-top: 35px !important;
        }
      }
    }
    .verify_mail {
      color: #3671A3;
      font-size: 11px;
      letter-spacing: 1.1px;
      line-height: 24px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    .order-number-custom {
      width: 100% !important;
      .el-input {
        width: 100% !important;
        .el-input__wrapper {
          .el-input__inner {
            text-align: left;
          }
        }
      }
    }
  }
  .white-space-pre-line {
    white-space: pre-line;
  }
</style>
